import { render, staticRenderFns } from "./DetalleTabs.vue?vue&type=template&id=7f55d484&"
import script from "./DetalleTabs.vue?vue&type=script&lang=ts&"
export * from "./DetalleTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7f55d484', component.options)
    } else {
      api.reload('7f55d484', component.options)
    }
    module.hot.accept("./DetalleTabs.vue?vue&type=template&id=7f55d484&", function () {
      api.rerender('7f55d484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/DetalleTabs.vue"
export default component.exports